exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".thumbnail{height:100px;display:flex}.thumbnail img{object-fit:contain}\n", ""]);

